export default __webpack_public_path__ + "static/media/Overlook.e7a6d7d6.jpg";